export default "__VITE_ASSET__5f5001a9__"